import { jsx } from "react/jsx-runtime";
import { Text } from "@zillow/constellation";
import { omit } from "lodash";
import PropTypes from "prop-types";
import "react";
import styled from "styled-components";
import { negativeMarginMixin } from "../../mixins/negativeMarginMixin.esm.js";
import ThemeCmsConstellation from "../../themes/ThemeCmsConstellation.esm.js";
import customPropTypes from "../../utils/custom-prop-types.esm.js";
const StyledHeading = styled(Text).withConfig({
  displayName: "Heading__StyledHeading",
  componentId: "sc-l044if-0"
})(["", ""], negativeMarginMixin);
const Placements = {
  page: "page",
  post: "post"
};
const POST_FONT_TYPE_BY_AS = {
  h1: {
    default: "h4",
    md: "h3",
    xl: "h3"
  },
  h2: {
    default: "h5",
    md: "h4",
    xl: "h4"
  },
  h3: {
    default: "h6",
    md: "h5",
    xl: "h5"
  },
  h4: {
    default: "h6",
    md: "h6",
    xl: "h6"
  },
  h5: {
    default: "bodySmallHeading",
    md: "bodySmallHeading",
    xl: "bodySmallHeading"
  },
  h6: {
    default: "finePrintHeading",
    md: "finePrintHeading",
    xl: "finePrintHeading"
  }
};
const POST_MARGINS = {
  h2: {
    marginTop: "md",
    marginBottom: "sm"
  },
  h3: {
    marginTop: "md",
    marginBottom: "xs"
  },
  h4: {
    marginTop: "sm",
    marginBottom: "xs"
  },
  h5: {
    marginTop: "sm",
    marginBottom: "xxs"
  },
  h6: {
    marginTop: "sm",
    marginBottom: "none"
  }
};
const Heading = ({
  placement,
  ...rest
}) => {
  if (placement === Placements.post) {
    return /* @__PURE__ */ jsx(PostHeading, { ...rest });
  }
  return /* @__PURE__ */ jsx(StyledHeading, { ...rest });
};
const PostHeading = ({
  as,
  ...rest
}) => /* @__PURE__ */ jsx(StyledHeading, { as, ...omit(rest, "margin"), fontType: POST_FONT_TYPE_BY_AS[as], ...POST_MARGINS[as] });
const AsPropType = PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]);
PostHeading.propTypes = {
  as: AsPropType.isRequired
};
Heading.propTypes = {
  as: AsPropType.isRequired,
  fontColor: PropTypes.oneOf(Object.keys(ThemeCmsConstellation.constellation.colors)).isRequired,
  fontFamily: PropTypes.oneOf(["serif", "sansSerif"]).isRequired,
  margin: customPropTypes.inlineMediaQuery(PropTypes.shape({
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginLeft: PropTypes.string,
    marginBottom: PropTypes.string
  })),
  placement: PropTypes.oneOf(Object.keys(Placements)).isRequired,
  // Ignored if placement is `Placements.post`, so it's optional. However if
  // placement is `Placements.page`, then this is required.
  fontType: customPropTypes.inlineMediaQuery(PropTypes.string),
  textAlign: customPropTypes.inlineMediaQuery(PropTypes.oneOf(["center", "left", "right"]))
};
export {
  Heading as default
};
